enum StatsEnum {
  Load = "LOAD",
  AddDayStats = "ADD_DAY",
  AddNightStats = "ADD_NIGHT",
}

export default StatsEnum;
